import React, { useEffect, useState } from "react";
import {
    Modal,
    Row,
    Col,
    Card,
    Typography,
    Descriptions,
    Tag,
    Table,
    Button,
    Input,
    Select,
    message,
    DatePicker,
    Steps,
    Popconfirm,
    Space,
} from "antd";
import {
    ClockCircleOutlined,
    UserOutlined,
    PhoneOutlined,
    HomeOutlined,
    UsergroupAddOutlined,
    CloseOutlined,
    SaveOutlined,
    PlusCircleOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { consoleLogUtil } from "../../../utils/consoleLogUtil";
import { FORMAT_DATE, HeaderTableChildCus, LIST_SEX, STATUS_SERVICES, TYPE_COMMISSION, TYPE_MODAL, TYPE_TICKET } from "../../../constants/constants";
import { formatNumber, getSelectedBranch } from "../../../utils/funcHelper";
import dayjs from "../../../utils/dayjsConfig";
import EkipDetailDrawer from "./EkipDetailDrawer";
import LoadingBase from "../../../components/LoadingBase";
import { add_customer_care_log, delete_customer_care_log, get_customer_care_log_detail, list_customer_care_logs_nopage, service_sessions_create, service_sessions_delete, service_sessions_detail, service_sessions_list, update_customer_care_log } from "../../../services/apis";
import { Images } from "../../../assets";
import SupportDetailDrawer from "./SupportDetailDrawer";

const { Title, Text } = Typography;
const ServiceDetailModal = ({ visible, onClose, onSave, data, employees, services, positions }) => {
    const [consultanter, setConsultanter] = useState();
    const userReducer = useSelector((state) => state?.userReducer?.data);
    const [open, setOpen] = useState(false);
    const [openSupportDrawer, setOpenSupportDrawer] = useState(false);
    const [customerName, setCustomerName] = useState("");
    const [customerPhone, setCustomerPhone] = useState("");
    const [customerAddress, setCustomerAddress] = useState("");
    const [lstServicesRegistered, setLstServicesRegistered] = useState([]);
    const [typeDrawer, setTypeDrawer] = useState();
    const [itemSelected, setItemSelected] = useState();
    const [itemSupportSelected, setItemSupportSelected] = useState();
    const [randomID, setRandomID] = useState(Math.floor(Math.random() * 1000000));
    const [customerDOB, setCustomerDOB] = useState(null); // Ngày sinh
    const [customerGender, setCustomerGender] = useState(LIST_SEX[1].value); // Giới tính
    const [statusService, setStatusService] = useState(); // Trạng thái dịch vụ
    const [currentSteps, setCurrentSteps] = useState();
    const [loading, setLoading] = useState(false);
    const [dataSessions, setDataSessions] = useState([]);
    const [dataSupports, setDataSupports] = useState([]);

    const columns = [
        {
            title: "STT",
            render: (src, record, index) => index + 1,
            align: "center",
            width: 50,
        },
        {
            title: "Tên dịch vụ",
            dataIndex: "service_name",
            key: "service_name",
            width: 300,
            fixed: 'left',
            render: (text, record) => <a>{text}</a>,
        },
        {
            title: "Loại vé",
            dataIndex: "ticket_type_name",
            key: "ticket_type_name",
            align: "center",
            width: 100,
        },
        {
            title: "Đơn giá (vnđ)",
            dataIndex: "sale_price",
            key: "sale_price",
            align: "center",
            render: (price) => <Text strong>{formatNumber(parseInt(price), 0)}</Text>,
            width: 120,
        },
        {
            title: "Giảm giá",
            dataIndex: "discount",
            key: "discount",
            align: "center",
            render: (discount, record) => <Text>{record?.discount_type === TYPE_COMMISSION[0].value ? discount : formatNumber(parseInt(discount), 0)} {record?.discount_type === TYPE_COMMISSION[0].value ? "%" : "vnđ"}</Text>,
            width: 80,
        },

        {
            title: "S.buổi",
            dataIndex: "total_sessions",
            key: "total_sessions",
            align: "center",
            render: (total_sessions) => <Text strong>{total_sessions}</Text>,
            width: 60,
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            align: "center",
            width: 120,
            render: (status) => {
                let color = 'default';
                let text = 'N/A';
                if (status === STATUS_SERVICES[0].value) {
                    color = 'blue';
                    text = 'Đang thực hiện';
                } else if (status === STATUS_SERVICES[1].value) {
                    color = 'green';
                    text = 'Đã hoàn thành';
                } else if (status === STATUS_SERVICES[2].value) {
                    color = 'red';
                    text = 'Huỷ dịch vụ';
                }
                return <Tag color={color}>{text}</Tag>;
            }
        },
        {
            title: "Ngày bắt đầu",
            dataIndex: "start_date",
            key: "start_date",
            align: "center",
            width: 100,
        },
        {
            title: "Ngày kết thúc",
            dataIndex: "end_date",
            key: "end_date",
            align: "center",
            width: 100,
        },
    ];
    consoleLogUtil('data modal', data);
    const onChange = value => {
        if (value > currentSteps) {
            message.warning('Chưa thực hiện buổi này');
            return;
        }
    };

    const handleAddEkips = () => {
        // setRandomID(Math.floor(Math.random() * 1000000));
        // setTypeDrawer(TYPE_MODAL.ADD);
        // setOpen(true);
    }

    const handleEditEkips = async (record) => {
        consoleLogUtil('record edit ekip', record);
        try {
            const params = {
                id: record?.id,
            }
            setLoading(true);
            const res = await service_sessions_detail(params);
            consoleLogUtil('service_sessions_detail', res);
            if (res && res.status === 1) {
                setItemSelected(res?.data || null);
                setTypeDrawer(TYPE_MODAL.EDIT);
                setRandomID(Math.floor(Math.random() * 1000000));
                setOpen(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    const getDataSessions = async (isShowLoading) => {
        try {
            const params = {
                customer_service_id: data?.id,
            }
            if (isShowLoading)  setLoading(true);
            const res = await service_sessions_list(params);
            consoleLogUtil('service_sessions_list', res);
            if (res && res.status === 1) {
                setDataSessions(res?.data || []);
                setCurrentSteps(getCurrentStep(data?.total_sessions || 0, res?.data || []));
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setDataSessions([]);
                setCurrentSteps(0);
            }

        } catch (error) {
            consoleLogUtil('error', error);
        } finally {
            if (isShowLoading) setLoading(false);
        }
    }

    const calculateTotalAmount = () => {
        const total = lstServicesRegistered.filter(item => item?.status !== "3").reduce((total, item) => {
            return total + (item?.total_amount || 0);
        }, 0);
        return formatNumber(total);
    }

    const callAPIAddSupport = async (dataSupport) => {
        // Thêm mới nhật ký hỗ trợ
        try {
            const params = {
                customer_service_id: data?.id,
                customer_id: data?.customer_id,
                care_date: dataSupport?.care_date?.format(FORMAT_DATE.YYYYMMDD),
                care_method: dataSupport?.care_method || '',
                notes: dataSupport?.notes || '',
                care_result: dataSupport?.care_result || null,
                branch_id: getSelectedBranch()?.id ?? null,
                employee_id: userReducer?.user_info?.id,
            }
            setLoading(true);
            const res = await add_customer_care_log(params);
            if (res && res.status === 1) {
                message.success('Thêm nhật ký hỗ trợ thành công');
                getDataSupports(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    const callAPIUpdateSupport = async (dataSupport) => {
        // Cập nhật nhật ký hỗ trợ
        try {
            const params = {
                id: dataSupport?.id,
                care_date: dataSupport?.care_date?.format(FORMAT_DATE.YYYYMMDD),
                care_method: dataSupport?.care_method || '',
                notes: dataSupport?.notes || '',
                care_result: dataSupport?.care_result || null,
                updated_by: userReducer?.user_info?.id,
            }
            setLoading(true);
            const res = await update_customer_care_log(params);
            if (res && res.status === 1) {
                message.success('Cập nhật nhật ký hỗ trợ thành công');
                getDataSupports(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    const getDataSupports = async (isShowLoading) => {
        try {
            const params = {
                customer_service_id: data?.id,
                customer_id: data?.customer_id,
                branch_id: data?.branch_id,
            }
            if (isShowLoading) setLoading(true);
            const res = await list_customer_care_logs_nopage(params);
            consoleLogUtil('list_customer_care_logs_nopage', res);
            if (res && res.status === 1) {
                setDataSupports(res?.data?.data || []);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setDataSupports([]);
            }

        } catch (error) {
            consoleLogUtil('error', error);
        } finally {
            if (isShowLoading) setLoading(false);
        }
    }

    const handleSaveSupport = async (dataSupport) => {
        if (typeDrawer === TYPE_MODAL.ADD) {
        // Lưu nhật ký hỗ trợ
            await callAPIAddSupport(dataSupport);
        }
        if (typeDrawer === TYPE_MODAL.EDIT) {
            // Cập nhật nhật ký hỗ trợ
            await callAPIUpdateSupport(dataSupport);
        }
    }

    const handleSaveEkips = async (dataEkip) => {

        // Lưu buổi thực hiện dịch vụ của ekips
        // try {
        //     const params = {
        //         customer_service_id: data?.id,
        //         session_date: dataEkip?.session_date?.format(FORMAT_DATE.YYYYMMDD),
        //         notes: dataEkip?.notes || '',
        //         ekips: dataEkip?.ekips || [],
        //         created_by: userReducer?.user_info?.id,
        //     }
        //     setLoading(true);
        //     const res = await service_sessions_create(params);
        //     if (res && res.status === 1) {
        //         message.success('Thêm buổi thực hiện thành công');
        //         getDataSessions();
        //     } else {
        //         message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
        //     }
        // } catch (error) {

        // } finally {
        //     setLoading(false);
        // }

    }

    const getCurrentStep = (totalSessions, dataSessions) => {
        for (let i = 0; i < totalSessions; i++) {
            const session = dataSessions[i];
            if (!session || !session.session_date) {
                // Buổi chưa thực hiện
                return i;
            }
        }
        // Nếu tất cả các buổi đã thực hiện, trả về buổi cuối cùng
        return totalSessions - 1;
    };

    const handleEditSupport = async (record) => {

        try {
            const params = {
                id: record?.id,
            }
            setLoading(true);
            const res = await get_customer_care_log_detail(params);
            consoleLogUtil('get_customer_care_log_detail', res);
            if (res && res.status === 1) {
                setItemSupportSelected(res?.data || null);
                setTypeDrawer(TYPE_MODAL.EDIT);
                setRandomID(Math.floor(Math.random() * 1000000));
                setOpenSupportDrawer(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            consoleLogUtil('error', error);
        } finally {
            setLoading(false);
        }

        
    }

    const handleDeleteSupport = async (support) => {
        // Xoá nhật ký hỗ trợ
        try {
            const params = {
                id: support?.id,
                deleted_by: userReducer?.user_info?.id,
            }
            setLoading(true);
            const res = await delete_customer_care_log(params);
            if (res && res.status === 1) {
                message.success('Xoá nhật ký hỗ trợ thành công');
                getDataSupports(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    const handleDeleteSessionEkip = async (session) => {
        // Xoá buổi thực hiện dịch vụ của ekips
        try {
            const params = {
                id: session?.id,
                updated_by: userReducer?.user_info?.id,
            }
            setLoading(true);
            const res = await service_sessions_delete(params);
            if (res && res.status === 1) {
                message.success('Xoá buổi thực hiện thành công');
                getDataSessions(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    const generateStepsItems = (totalSessions, dataSessions) => {
        // Tạo danh sách các buổi
        const items = [];
        const current = getCurrentStep(totalSessions, dataSessions);
        for (let i = 0; i < totalSessions; i++) {
            const session = dataSessions[i]; // Lấy buổi đã thực hiện nếu có
            if (session) {
                // Buổi đã thực hiện
                items.push({
                    title: (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <a onClick={() => handleEditEkips(session)}>Buổi {i + 1} - {dayjs(session.session_date, FORMAT_DATE.YYYYMMDD).format(FORMAT_DATE.DDMMYYYY)}</a>
                            <Popconfirm
                                title="Xác nhận huỷ buổi này?"
                                onConfirm={() => handleDeleteSessionEkip(session)}
                                okText="Đồng ý"
                                cancelText="Đóng"
                            >
                                <CloseOutlined style={{ color: 'red', marginLeft: 16 }} />
                            </Popconfirm>
                        </div>
                    ),
                    description: session.notes || 'Không có ghi chú',
                });
            } else {
                // Buổi chưa thực hiện
                if (i === current) {
                    items.push({
                        title: <a onClick={() => handleAddEkips()}>Buổi {i + 1}</a>,
                        description: 'Chưa thực hiện',
                    });
                } else {
                    items.push({
                        title: `Buổi ${i + 1}`,
                        description: 'Chưa thực hiện',
                    });
                }

            }
        }

        return items;
    };

    const handleAddSupport = () => {
        setRandomID(Math.floor(Math.random() * 1000000));
        setTypeDrawer(TYPE_MODAL.ADD);
        setOpenSupportDrawer(true);
    }

    const generateStepsItemsSupport = (dataSupport) => {
        // Tạo danh sách các buổi
        const items = [];
        for (let i = 0; i < dataSupport?.length; i++) {
            const support = dataSupport[i]; // Lấy nội dung support
            if (support) {
                // Buổi đã thực hiện
                items.push({
                    title: (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <a onClick={() => handleEditSupport(support)}>Chăm sóc bởi {support?.employee_name ?? ''} - {dayjs(support.care_date).format(FORMAT_DATE.DDMMYYYY)}</a>
                            <Popconfirm
                                title="Xác nhận huỷ chăm sóc này?"
                                onConfirm={() => handleDeleteSupport(support)}
                                okText="Đồng ý"
                                cancelText="Đóng"
                            >
                                <CloseOutlined style={{ color: 'red', marginLeft: 16 }} />
                            </Popconfirm>
                        </div>
                    ),
                    description: <span style={{color: 'black'}}>{support.notes || 'Không có ghi chú'}</span>,
                    icon: <img src={Images.ic_customer_service} alt="user" width={30} height={30} />,
                });
            }
        }

        return items;
    };

    const onCloseDrawer = () => {
        setOpen(false);
    }
    const onCloseDrawerSupport = () => {
        setOpenSupportDrawer(false);
    }
    const handleOnSaveModal = () => {
        if (data?.status !== statusService) {
            // Cập nhật trạng thái dịch vụ
            onSave({
                ...data,
                status: statusService,
            });
            onClose();
        } else {
            onClose();
        }
    }

    useEffect(() => {
        if (data) {
            setLoading(true);
            Promise.all([getDataSessions(false), getDataSupports(false)]).finally(() => { setLoading(false); });
            setCustomerName(data?.customer_name || '');
            setCustomerPhone(data?.customer_phone || '');
            setCustomerAddress(data?.customer_address || '');
            setConsultanter(data?.consultant_id ?? null);
            setCustomerDOB(data?.birthday ? dayjs(data?.birthday, FORMAT_DATE.YYYYMMDD) : null);
            setCustomerGender(data?.customer_gender ?? null);
            setStatusService(data?.status ?? null);
            const itemService = {
                service_name: data?.service_name || '',
                ticket_type_name: data?.type ? TYPE_TICKET.find(item => item.value === data?.type)?.label : 'N/A',
                sale_price: data?.sale_price || 0,
                discount: data?.discount_value || 0,
                discount_type: data?.discount_type || TYPE_COMMISSION[1].value,
                total_sessions: data?.total_sessions || 0,
                status: data?.status || STATUS_SERVICES[0].value,
                start_date: data?.start_date || '',
                end_date: data?.end_date || '',
                total_amount: data?.total_amount ? parseFloat(data?.total_amount) : 0,
            }
            setLstServicesRegistered([itemService]);
        }
    }, [visible, data]);

    return (
        <Modal
            title="Thông tin dịch vụ"
            open={visible}
            onCancel={onClose}
            width={'90%'}
            bodyStyle={{ backgroundColor: "#f5f5f5", padding: 16 }}
            className="custom-modal"
            footer={[
                <Button
                    icon={<CloseOutlined />}
                    key="cancel" onClick={onClose}>
                    Đóng
                </Button>,
                <Button
                    key="save"
                    type="primary"
                    onClick={() => handleOnSaveModal()}
                    icon={<SaveOutlined />}
                >
                    Lưu
                </Button>,
            ]}
        >
            <Row gutter={16}>
                {/* CỘT TRÁI */}
                <Col span={16}>
                    <Card size="small" style={{ marginBottom: 16, borderRadius: 8 }}>
                        <Title level={5}>Thông tin chung</Title>
                        <Descriptions
                            column={1}
                            bordered
                            size="middle"
                            labelStyle={{ width: "25%", fontWeight: 500, background: "#fafafa", fontSize: 14, color: 'black', fontFamily: 'Roboto, Arial, sans-serif' }}
                            contentStyle={{ textAlign: "right", padding: "8px 12px" }}
                        >

                            <Descriptions.Item label={<><UserOutlined /> Họ và tên *</>}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Input
                                        placeholder="Nhập họ và tên"
                                        style={{ width: '60%', textAlign: 'left' }}
                                        disabled
                                        value={customerName}
                                        onChange={(e) => setCustomerName(e.target.value)}
                                    />
                                    <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 16, width: '40%', alignItems: 'center' }}>
                                        <Text style={{ marginRight: 8, width: 120 }}>Giới tính(*):</Text>
                                        <Select
                                            placeholder="Chọn giới tính"
                                            allowClear
                                            value={customerGender}
                                            onChange={setCustomerGender}
                                            style={{ width: '100%', textAlign: 'left', height: 40 }}
                                            options={LIST_SEX}
                                            disabled
                                        />

                                    </div>
                                </div>

                            </Descriptions.Item>
                            <Descriptions.Item label={<><PhoneOutlined /> Số điện thoại *</>}>

                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Input
                                        placeholder="Nhập số điện thoại"
                                        style={{ width: '60%', textAlign: 'left' }}
                                        disabled
                                        value={customerPhone}
                                        onChange={(e) => setCustomerPhone(e.target.value)}
                                    />
                                    <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 16, width: '40%', alignItems: 'center' }}>
                                        <Text style={{ marginRight: 8, width: 120 }}>Ngày sinh:</Text>
                                        <DatePicker
                                            format={FORMAT_DATE.DDMMYYYY}
                                            placeholder="Chọn ngày sinh"
                                            style={{ width: '100%', textAlign: 'left', height: 40 }}
                                            value={customerDOB}
                                            onChange={(date, dateString) => setCustomerDOB(date)}
                                            disabled
                                        />

                                    </div>
                                </div>
                            </Descriptions.Item>
                            <Descriptions.Item label={<><HomeOutlined /> Địa chỉ</>}>
                                <Input
                                    placeholder="Nhập địa chỉ"
                                    style={{ width: '100%', textAlign: 'left' }}
                                    disabled
                                    value={customerAddress}
                                    onChange={(e) => setCustomerAddress(e.target.value)}
                                />
                            </Descriptions.Item>
                            <Descriptions.Item label={<><UsergroupAddOutlined /> Người tư vấn</>}>

                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Select
                                        placeholder="Chọn người tư vấn"
                                        allowClear
                                        value={consultanter}
                                        onChange={setConsultanter}
                                        style={{ width: '50%', textAlign: 'left', height: 40, display: 'block' }}
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                        options={employees}
                                        disabled
                                    />
                                    <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 16, width: '50%', alignItems: 'center' }}>
                                        <Text style={{ marginRight: 8, width: 120 }}>Trạng thái(*):</Text>
                                        <Select
                                            value={statusService}
                                            onChange={setStatusService}
                                            style={{ width: '100%', textAlign: 'left', height: 40 }}
                                            options={STATUS_SERVICES}
                                        />

                                    </div>
                                </div>
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>

                    {/* Items */}
                    <Card size="small" style={{ borderRadius: 8 }}>
                        <Title level={5}>Dịch vụ đăng ký</Title>
                        <Table
                            components={HeaderTableChildCus}
                            columns={columns}
                            dataSource={lstServicesRegistered}
                            pagination={false}
                            rowKey={(record) => record.id}
                            scroll={{ x: 'max-content' }}
                        />
                    </Card>
                    <Card size="small" style={{ borderRadius: 8, marginTop: 16 }}>
                        <Space align="center" style={{ marginBottom: 16, width: '100%' }}>
                            <Title level={5}>Nhật ký hỗ trợ</Title>
                            <Button
                                onClick={() => handleAddSupport()}
                                style={{ height: 32, marginLeft: 12 }}
                                danger
                                type="dashed"
                                icon={<PlusCircleOutlined />}>
                                Thêm hỗ trợ
                            </Button>
                        </Space>

                        <Steps
                            onChange={onChange}
                            direction="vertical"
                            style={{ maxHeight: '300px', overflowY: 'scroll' }}
                            items={generateStepsItemsSupport(dataSupports)}
                        />
                    </Card>

                </Col>

                {/* CỘT PHẢI */}
                <Col span={8}>
                    <Card size="small" style={{ marginBottom: 16, borderRadius: 8 }}>
                        <Title level={5}>Thông tin thanh toán</Title>
                        {
                            lstServicesRegistered?.length > 0 ?
                                lstServicesRegistered.map((item, index) => {
                                    if (item.status === '3') return null; // Bỏ qua dịch vụ có trạng thái "Huỷ dịch vụ"
                                    return (
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                                            <span>{index + 1}. {item?.service_name ?? ''}</span>
                                            <Text strong style={{ textAlign: 'right' }}>{formatNumber(item?.total_amount)}</Text>
                                        </div>
                                    )
                                })
                                : null
                        }

                        <div style={{ borderTop: '1px solid #d9d9d9', margin: '12px 0' }}></div> {/* Đường gạch ngang */}
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Title level={5} style={{ margin: 0 }}>Thành tiền (vnđ):</Title>
                            <Title level={5} style={{ margin: 0, textAlign: 'right' }}>{calculateTotalAmount()}</Title>
                        </div>
                    </Card>
                    <Card size="small" className="scrollable-card">
                        <Title level={5}>Các buổi thực hiện</Title>
                        <Steps
                            current={currentSteps}
                            onChange={onChange}
                            direction="vertical"
                            items={generateStepsItems(data?.total_sessions || 0, dataSessions)}
                        />
                    </Card>


                </Col>
            </Row>
            <EkipDetailDrawer
                isOpen={open}
                onClose={onCloseDrawer}
                onSave={handleSaveEkips}
                services={services}
                type={typeDrawer}
                randomID={randomID}
                data={itemSelected}
                employees={employees}
                positions={positions}
            />
            <SupportDetailDrawer
                isOpen={openSupportDrawer}
                onClose={onCloseDrawerSupport}
                onSave={handleSaveSupport}
                services={services}
                type={typeDrawer}
                randomID={randomID}
                data={itemSupportSelected}
            />
            <LoadingBase loading={loading} />
        </Modal>
    );
};

export default ServiceDetailModal;
